import usePlanLabelPdfMetrics from './usePlanLabelPdfMetrics'

/** The plan label font's em size in world units — same value as `usePlanLabelPdfMetrics().emWorld`. */
const useLabelScaleFromPlanSettings = (): number => usePlanLabelPdfMetrics().emWorld

export default useLabelScaleFromPlanSettings
